export const enviroment = {
  baseApi: "",
  baseUrl: "http://localhost:3000/",
};